<div
  class="flex items-center justify-center w-full bg-quaternary border border-tertiary rounded-button cursor-pointer "
[class]="selected ? 'selected' : ''">
  <span [class]="textClasses" > <i *ngIf="icon != ''" [class]="icon"></i>{{text}}</span>
</div>